import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const BrandingPage: React.FC = () => {
  return <ServicePageTemplate slug="branding" />;
};

export default BrandingPage;
